"use client";

import { ChangeEvent, useState } from "react";
import { Button, Form, FormGroup } from "react-bootstrap";

import {
  getInputValue,
  handleSubmit,
  OryMessage,
  PasswordEye,
  Values,
} from "./flow-helper";
import type { Flow } from "./use-flow";
import { GetType } from "@/types/types";

export interface Props<T> {
  flow?: Flow;
  onSubmit: (Values: T) => Promise<void>;
  content: GetType<"api::auth.auth">;
  lang: string;
}

export function FlowLogin<T extends Values>({
  flow,
  onSubmit,
  content,
  lang,
}: Props<T>) {
  const [isLoading, setIsLoading] = useState(false);
  const [validIdentifier, setValidIdentifier] = useState<boolean>(false);
  const [validPassword, setValidPassword] = useState<boolean>(false);
  const [axiosError, setAxiosError] = useState<Flow>();
  const [passwordVisibility, setPasswordVisibility] = useState(true);

  function onIdentifierChange(e: ChangeEvent<HTMLInputElement>) {
    setValidIdentifier(e.target.value.length > 0);
  }

  function onPasswordChange(e: ChangeEvent<HTMLInputElement>) {
    setValidPassword(e.target.value.length > 0);
  }

  if (!flow) {
    return null;
  }

  return (
    <>
      {axiosError && (
        <OryMessage
          oryFlow={flow}
          axiosFlow={axiosError}
          content={content}
          lang={lang}
        />
      )}
      <Form
        onSubmit={(e) =>
          void handleSubmit(
            e,
            onSubmit,
            "password",
            isLoading,
            setIsLoading,
            setAxiosError,
          )
        }
        action={flow.ui.action}
        method={flow.ui.method}
      >
        <Form.Control
          readOnly
          name="csrf_token"
          value={getInputValue(flow, "csrf_token")}
          hidden
        ></Form.Control>
        <FormGroup>
          <Form.Label className=" fw-bold text-uppercase">
            {content.traits_identifier}
          </Form.Label>
          <Form.Control
            name="identifier"
            onChange={onIdentifierChange}
            className="auth-input-filed"
          ></Form.Control>
        </FormGroup>
        <br />
        <FormGroup>
          <Form.Label className=" fw-bold text-uppercase">
            {content.traits_password?.field_name}
          </Form.Label>
          <div className="d-flex align-items-center justify-content-center position-relative">
            <Form.Control
              type={passwordVisibility ? "password" : "text"}
              name="password"
              onChange={onPasswordChange}
              className="auth-input-filed"
            ></Form.Control>
            <PasswordEye
              passwordVisibility={passwordVisibility}
              setPasswordVisibility={setPasswordVisibility}
              warning={false}
            />
          </div>
        </FormGroup>
        <br />
        <FormGroup className="d-flex align-items-center justify-content-center">
          <Button
            className="border-button py-3 px-5"
            type="submit"
            disabled={!validIdentifier || !validPassword || isLoading}
          >
            {content.button_login}
          </Button>
        </FormGroup>
      </Form>
    </>
  );
}
